import { SHOW_ALERT, SHOW_MESSAGE } from '@sm/actions/types';

export const showMessage = message => dispatch => {
  const data = {
    message,
    show: true
  };

  dispatch({ type: SHOW_MESSAGE, payload: data });

  setTimeout(() => {
    dispatch({ type: SHOW_MESSAGE, payload: data.show = false });
  }, 5000);
};

export const showAlert = (show, type, message, callback, btnText) => dispatch => {
  const data = {
    show,
    type,
    message,
    btnText,
    callback
  };

  dispatch({ type: SHOW_ALERT, payload: data });
};
